import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import ProductList from "@/components-v2/product/product-list";
import PageTop from "@/components-v2/layout/page-top";
import PageTop1 from "@/components-v2/layout/page-top1";
import PageBottom from "@/components-v2/layout/page-bottom";
import { purchaseQuantityProcessing } from '@/utils';
import { kv } from "../../mixin/kv";
export default {
  mixins: [kv],
  data: function data() {
    return {
      list: [],
      pcImg: null,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      queryParam: {
        id: this.$route.params.id,
        pageSize: 20,
        activity: null,
        page: 1
      }
    };
  },
  components: {
    ProductList: ProductList,
    PageTop: PageTop,
    PageTop1: PageTop1,
    PageBottom: PageBottom
  },
  created: function created() {
    this.getData();
    this.kv_visit("1", this.$route.params.id);
  },
  watch: {
    '$route.params': function $routeParams() {
      this.kv_visit("1", this.$route.params.id);
    }
  },
  methods: {
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/pjyy-deepexi-product-center/api/v4/product/PcProductCommon/banner";
              _context.next = 3;
              return _this.$getHttpClient().post(url, _this.queryParam);
            case 3:
              result = _context.sent;
              if (result.data.code == '200') {
                _this.list = purchaseQuantityProcessing(result.data.data.list);
                _this.pcImg = result.data.data.pcImg;
                _this.pageInfo.total = result.data.data.total;
                _this.pageInfo.pageNum = result.data.data.pageNum;
                _this.pageInfo.pageSize = result.data.data.pageSize;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getDataByPage: function getDataByPage(data) {
      this.queryParam.page = data.pageNum;
      this.getData();
    }
  }
};